import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import Layout from "../../components/layout/layout";
import axiosInstance from "../../AxiosInstance";
import { toast, ToastTypes } from "../../components/ajonjolib/toasts/toast/toast";
import TimezoneCard from "./components/timezone_card";
import MapCenterCard from "./components/map_center_card";
import ConnectionAlertCard from "./components/connection_alert_card";
import AlertEmailsCard from "./components/alert_emails_card";
import styles from "./company.module.css";
import { isAdmin } from "../../utils/roles";

// Configuración de la empresa: zona horaria (de la plataforma y de todos sus
// PDUI), centrado del mapa y correos de alerta. La puede cambiar cualquier
// usuario de la empresa; el backend solo deja tocar la propia.
export default function Company() {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [countries, setCountries] = useState([]);
  const [loadError, setLoadError] = useState(false);
  const hasImu = localStorage.getItem("has_imu") === "true";

  const reload = useCallback(
    () =>
      axiosInstance
        .get("company/settings/")
        .then((response) => {
          setData(response.data);
          setLoadError(false);
          try {
            localStorage.setItem("has_imu", String(!!response.data.company.has_imu));
          } catch (e) {
            // sin storage no se recuerda
          }
        })
        .catch(() => setLoadError(true)),
    [],
  );

  useEffect(() => {
    reload();
    axiosInstance
      .get("company/timezones/")
      .then((response) => setCountries(response.data.countries || []))
      .catch(() => toast(t("company.loadError"), ToastTypes.ERROR));
  }, [reload, t]);

  // Mismo orden que el menú lateral: Dashboard, PDUI's, [IMU], Empresa.
  const selectedIndex = hasImu ? 3 : 2;
  // El backend rechaza los cambios de quien no es admin; aquí se avisa y se
  // deja todo en solo lectura para que la pantalla no prometa lo que no puede.
  const admin = isAdmin();

  return (
    <Layout selectedIndex={selectedIndex}>
      <div className={styles.page}>
        <div className={styles.header}>
          <div>
            <div className={styles.title}>{t("company.title")}</div>
            <div className={styles.subtitle}>{t("company.subtitle")}</div>
          </div>
          {data && (
            <div className={styles.companyBadge}>
              <FontAwesomeIcon icon={faBuilding} />
              {data.company.name}
            </div>
          )}
        </div>

        {!data && (
          <div className={styles.card}>
            <div className={styles.loading}>
              {loadError ? t("company.loadError") : t("company.loading")}
            </div>
          </div>
        )}

        {data && !admin && (
          <div className={styles.readOnlyBanner}>{t("roles.companyReadOnly")}</div>
        )}

        {data && (
          <div className={admin ? undefined : styles.readOnly}>
            <TimezoneCard data={data} setData={setData} countries={countries} reload={reload} />
            {data.company.has_imu && <MapCenterCard company={data.company} setData={setData} />}
            <ConnectionAlertCard company={data.company} setData={setData} />
            <AlertEmailsCard data={data} setData={setData} />
          </div>
        )}
      </div>
    </Layout>
  );
}
